import { useContext } from 'react';

import { GroundContext, type GroundContextType } from '@/contexts/GroundContext';

/** Access Ground settings, stats, identity, and local progress. */
export function useGround(): GroundContextType {
  const context = useContext(GroundContext);
  if (context === undefined) {
    throw new Error('useGround must be used within a GroundProvider');
  }
  return context;
}
